module.exports = __webpack_public_path__ + "img/arrow_back-24px.309817cf.svg";